import type { IconData } from '@stacksjs/iconify-core'

export const target3: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path fill=\"#fff\" d=\"M9 24c0-8.284 6.716-15 15-15s15 6.716 15 15s-6.716 15-15 15S9 32.284 9 24\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 24c0-8.284 6.716-15 15-15s15 6.716 15 15s-6.716 15-15 15S9 32.284 9 24M24 9v4m15 11h-4M24 39v-4M9 24h4m8 0h6m-3-3v6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default target3
